import { Text } from '@mantine/core';
import { formatFieldErrors } from '../lib/fieldErrors';

/**
 * Inline-Fehlerzeile der Dialoge/Formulare (F7, Optimierung 2026-08-25).
 *
 * Vorher stand `{x.error && <Text c="red">{x.error.message}</Text>}` an über
 * zwanzig Stellen — und zeigte damit nur die Kopfmeldung. Die feldgenauen
 * 400er der API (errors[]) unterdrückt der globale Toast bewusst
 * (lib/queryClient); wer sie nicht selbst rendert, verschluckt sie. Dieses
 * Bauteil rendert Kopfmeldung UND Felddetails über formatFieldErrors.
 */
export function FormError({ error, testId }: { error: unknown; testId?: string }) {
  if (!error) return null;
  const fallback = error instanceof Error ? error.message : 'Unbekannter Fehler.';
  return (
    <Text c="red" size="sm" data-testid={testId}>
      {formatFieldErrors(error, fallback)}
    </Text>
  );
}
